/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const pad = (n) => String(n).padStart(2, '0');

/** Chip di countdown (giorni/ore/minuti/secondi) fino all'inizio della visita. */
export const CountdownChips = ({ cd }) => (
  <AnimatePresence mode="wait">
    <motion.div
      key={`${cd.days}-${cd.hours}-${cd.minutes}`}
      initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
      className="flex items-center gap-1.5 flex-wrap"
      data-testid="patient-hero-countdown"
    >
      {cd.days > 0 && (
        <span className="rounded-lg bg-background/70 border px-2 py-0.5 text-xs">
          <b>{cd.days}</b>g
        </span>
      )}
      <span className="rounded-lg bg-background/70 border px-2 py-0.5 text-xs">
        <b>{pad(cd.hours)}</b>h
      </span>
      <span className="rounded-lg bg-background/70 border px-2 py-0.5 text-xs">
        <b>{pad(cd.minutes)}</b>m
      </span>
      {cd.days === 0 && cd.hours === 0 && (
        <span className="rounded-lg bg-primary/15 text-primary border-0 px-2 py-0.5 text-xs animate-pulse">
          <b>{pad(cd.seconds)}</b>s
        </span>
      )}
    </motion.div>
  </AnimatePresence>
);
